class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.lightbox = this.querySelector('[data-gallery-lightbox]');
    this.lightboxImg = this.querySelector('[data-gallery-lightbox-img]');

    this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId));
    });

    this.querySelectorAll('[data-gallery-zoom-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.openLightbox(trigger));
    });

    if (this.lightbox) {
      this.querySelectorAll('[data-gallery-lightbox-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeLightbox());
      });
      this.querySelector('[data-gallery-lightbox-prev]').addEventListener('click', () => this.stepLightbox(-1));
      this.querySelector('[data-gallery-lightbox-next]').addEventListener('click', () => this.stepLightbox(1));
      document.addEventListener('keydown', (event) => {
        if (this.lightbox.hidden) return;
        if (event.key === 'Escape') this.closeLightbox();
        if (event.key === 'ArrowLeft') this.stepLightbox(-1);
        if (event.key === 'ArrowRight') this.stepLightbox(1);
      });
    }
  }

  showMedia(mediaId) {
    this.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId));
    });
    this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
    });
  }

  openLightbox(trigger) {
    if (!this.lightbox) return;
    this.activeIndex = this.slides.findIndex((slide) => slide.contains(trigger));
    this.renderLightbox();
    this.lightbox.hidden = false;
  }

  closeLightbox() {
    if (this.lightbox) this.lightbox.hidden = true;
  }

  stepLightbox(delta) {
    this.activeIndex = (this.activeIndex + delta + this.slides.length) % this.slides.length;
    this.renderLightbox();
  }

  renderLightbox() {
    const slide = this.slides[this.activeIndex];
    if (!slide) return;
    const trigger = slide.querySelector('[data-gallery-zoom-trigger]');
    const img = slide.querySelector('img');
    this.lightboxImg.src = trigger.dataset.zoomSrc;
    this.lightboxImg.alt = img ? img.alt : '';
    this.showMedia(slide.dataset.mediaId);
  }
}

customElements.define('product-gallery', ProductGallery);
